import FullDisclosureModal from './FullDisclosureModal';

export default FullDisclosureModal;
